import React from 'react';
import { useTranslation } from 'react-i18next';

import Typography from '@material-ui/core/Typography';

import SelectCompany from 'assets/select-company.png';

import useStyles from './styles';

const SelectCompanyBox = () => {
  const classes = useStyles();
  const [t] = useTranslation();

  return (
    <div className={classes.root}>
      <div className={classes.box}>
        <img src={SelectCompany} alt="Select company" />
        <Typography variant="body1" className={classes.text}>
          {t(
            'Please select Business Owner Company to view all appropriate data'
          )}
        </Typography>
      </div>
    </div>
  );
};

export default SelectCompanyBox;
